import TeamPWIcon from '../images/tools/Team-PW.png'
import NumberPWIcon from '../images/tools/Number-PW.png'
import YesNoPWIcon from '../images/tools/Yes-No-PW.png'
import LetterPWIcon from '../images/tools/Letter-PW.png'
import ImagePWIcon from '../images/tools/Image-PW.png'
import CountryPWIcon from '../images/tools/Country-PW.png'
import DatePWIcon from '../images/tools/Date-PW.png'
import ColorPWIcon from '../images/tools/Color-PW.png'
import NFLPWIcon from '../images/tools/NFL-PW.png'
import NBAPWIcon from '../images/tools/NBA-PW.png'
import MLBPWIcon from '../images/tools/MLB-PW.png'
import StatePWIcon from '../images/tools/State-PW.png'
import PWIcon from '../images/Picker-Wheel-Logo-Small.png'
import IGCommentPWIcon from '../images/tools/Instagram-Comment-PW.png'

const ToolData = [
  {
    page: 'name',
    name: 'Picker Wheel',
    title: 'Picker Wheel',
    image: 'PickerWheel',
    description:
      'This is a random picker wheel which will spin and make a decision for you.',
    path: '/',
    icon: PWIcon,
  },
  {
    page: 'rtg',
    name: 'Team Picker Wheel',
    title: 'Team Picker Wheel',
    image: 'RTG',
    description:
      'This is a random team generator which will do grouping from a list of names.',
    path: '/tools/random-team-generator/',
    icon: TeamPWIcon,
  },
  {
    page: 'ynw',
    name: 'Yes No Picker Wheel',
    title: 'Yes No Picker Wheel',
    image: 'YNW',
    description:
      'This is a random yes or no wheel which will help you to make a yes no decision.',
    path: '/tools/yes-or-no-wheel/',
    icon: YesNoPWIcon,
  },
  {
    page: 'rng',
    name: 'Number Picker Wheel',
    title: 'Number Picker Wheel',
    image: 'RNG',
    description:
      'This is a rng tool which will help you to pick a number randomly.',
    path: '/tools/random-number-generator/',
    icon: NumberPWIcon,
  },
  {
    page: 'rlg',
    name: 'Letter Picker Wheel',
    title: 'Letter Picker Wheel',
    image: 'RLG',
    description:
      'This is a random letter generator which helps to pick a random alphabet.',
    path: '/tools/random-letter-generator/',
    icon: LetterPWIcon,
  },
  {
    page: 'rcg',
    name: 'Country Picker Wheel',
    title: 'Country Picker Wheel',
    image: 'RCG',
    description:
      'This is a random country generator which helps to pick a random country.',
    path: '/tools/random-country-generator/',
    icon: CountryPWIcon,
  },
  {
    page: 'rsg',
    name: 'State Picker Wheel',
    title: 'State Picker Wheel',
    image: 'RSG',
    description:
      'This is a random state generator which helps to pick a random state.',
    path: '/tools/random-state-generator/',
    icon: StatePWIcon,
  },
  {
    page: 'rcw',
    name: 'Color Picker Wheel',
    title: 'Color Picker Wheel',
    image: 'RCW',
    description:
      'This is a random color wheel which helps to pick a random color.',
    path: '/tools/random-color-generator/',
    icon: ColorPWIcon,
  },
  {
    page: 'rig',
    name: 'Image Picker Wheel',
    title: 'Image Picker Wheel',
    image: 'RIG',
    description:
      'A random image generator which picks a random picture from pictures provided.',
    path: '/tools/random-image-generator/',
    icon: ImagePWIcon,
  },
  {
    page: 'rdg',
    name: 'Date Picker Wheel',
    title: 'Date Picker Wheel',
    image: 'RDG',
    description:
      'This is a random date generator which helps to pick a random date.',
    path: '/tools/random-date-generator/',
    icon: DatePWIcon,
  },
  {
    page: 'icp',
    name: 'Instagram Comment Picker Wheel',
    title: ['Instagram Comment', 'Picker Wheel'],
    image: 'ICP',
    description: 'This is an Instagram giveaway generator.',
    path: '/tools/instagram-comment-picker/',
    icon: IGCommentPWIcon,
  },
  {
    page: 'mlb',
    name: 'MLB Picker Wheel',
    title: 'MLB Picker Wheel',
    image: 'MLB',
    description:
      'This is a MLB team wheel which helps to pick a random MLB team.',
    path: '/tools/random-mlb-team-generator/',
    icon: MLBPWIcon,
  },
  {
    page: 'nba',
    name: 'NBA Picker Wheel',
    title: 'NBA Picker Wheel',
    image: 'NBA',
    description:
      'This is a NBA team wheel which helps to pick a random NBA team.',
    path: '/tools/random-nba-team-generator/',
    icon: NBAPWIcon,
  },
  {
    page: 'nfl',
    name: 'NFL Picker Wheel',
    title: 'NFL Picker Wheel',
    image: 'NFL',
    description:
      'This is a NFL team wheel which helps to pick a random NFL team.',
    path: '/tools/random-nfl-team-generator/',
    icon: NFLPWIcon,
  },
]

export default ToolData
